import { render, staticRenderFns } from "./ProfileTalentStats.vue?vue&type=template&id=3eddfe0a"
import script from "./ProfileTalentStats.vue?vue&type=script&lang=js"
export * from "./ProfileTalentStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports